import { Layout } from 'antd'
import { PropsWithChildren } from 'react'

import { useStyles } from './styles'

export const Content = ({ children }: PropsWithChildren) => {
  const { styles } = useStyles()

  return <Layout.Content className={styles.content}>{children}</Layout.Content>
}
